import React from 'react';
import { Stack, TextField } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';

const ModalFechasCurso = () => {
    const { control, watch } = useFormContext();

    const fechaInicio = watch('fechaInicioCurso');

    // Función para obtener fecha de hoy en formato YYYY-MM-DD
    const getFechaHoy = () => {
        const hoy = new Date();
        const year = hoy.getFullYear();
        const month = String(hoy.getMonth() + 1).padStart(2, '0');
        const day = String(hoy.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Función para obtener fecha mínima para fecha fin
    const getFechaMinFin = () => {
        if (!fechaInicio) return getFechaHoy();
        const fecha = new Date(fechaInicio);
        fecha.setDate(fecha.getDate() + 1); // Mínimo un día después
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const day = String(fecha.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <Stack spacing={3} sx={{ mt: 2, mb: 2 }}>
            <Controller
                control={control}
                name="fechaInicioCurso"
                defaultValue={getFechaHoy()}
                rules={{
                    required: 'La fecha de inicio es requerida'
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <TextField
                        label="Fecha inicio del curso"
                        type="datetime-local"
                        value={value || getFechaHoy()}
                        onChange={onChange}
                        error={!!error}
                        helperText={error?.message}
                        fullWidth
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            min: getFechaHoy()
                        }}
                    />
                )}
            />
            <Controller
                control={control}
                name="fechaFinCurso"
                defaultValue=""
                rules={{
                    required: 'La fecha de fin es requerida',
                    validate: (value) => {
                        if (!value) return 'La fecha de fin es requerida';
                        if (fechaInicio && new Date(value) <= new Date(fechaInicio)) {
                            return 'La fecha de fin debe ser mayor a la fecha de inicio';
                        }
                        return true;
                    }
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <TextField
                        label="Fecha fin del curso"
                        type="datetime-local"
                        value={value || ''}
                        onChange={onChange}
                        error={!!error}
                        helperText={error?.message}
                        fullWidth
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            min: getFechaMinFin()
                        }}
                    />
                )}
            />
        </Stack>
    );
};

export default ModalFechasCurso;
